
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import StaticPageTemplate from '@/components/StaticTemplate';
import useTranslation from 'next-translate/useTranslation';
import type { GetStaticProps } from 'next';
import ForSection from '@/components/Services/ForSection';
import {
  HiOutlineCurrencyEuro,
  HiOutlinePresentationChartLine,
  HiOutlineShieldCheck,
  HiOutlineTruck,
  HiOutlineWrenchScrewdriver,
} from 'react-icons/hi2';
import WorkSection from '@/components/Services/WorkSection';
import ExpertiseSection from '@/components/Services/Expertise';
import ContactStorage from '@/components/Services/Storage/Contact';
import Installations from '@/components/Services/Storage/Installations';

function MyPage() {
  const { t } = useTranslation();
  const title = t('services:Warehouse Service.title');
  const subtitle = t('services:Warehouse Service.subtitle');

  const sellerBlocks = [
    {
      title: t('services:Warehouse Service.blockSell1'),
      icon: <HiOutlineShieldCheck className='text-2xl' />,
    },
    {
      title: t('services:Warehouse Service.blockSell2'),
      icon: <HiOutlineWrenchScrewdriver className='text-2xl' />,
    },
    {
      title: t('services:Warehouse Service.blockSell3'),
      icon: <HiOutlinePresentationChartLine className='text-2xl' />,
    },
  ];
  const buyerBlocks = [
    {
      title: t('services:Warehouse Service.blockBuy1'),
      icon: <HiOutlineShieldCheck className='text-2xl' />,
    },
    {
      title: t('services:Warehouse Service.blockBuy2'),
      icon: <HiOutlineCurrencyEuro className='text-2xl' />,
    },
    {
      title: t('services:Warehouse Service.blockBuy3'),
      icon: <HiOutlineTruck className='text-2xl' />,
    },
  ];

  const components = [
    <ForSection
      sellText={t('services:Warehouse Service.sellForText')}
      buyText={t('services:Warehouse Service.buyForText')}
      key={'for'}
      buyerBlocks={buyerBlocks}
      sellerBlocks={sellerBlocks}
    />,
    <WorkSection
      sellText={t('services:Warehouse Service.sellingProcess')}
      buyText={t('services:Warehouse Service.buyingProcess')}
      key={'work'}
    />,
    <ExpertiseSection
      text={t('services:Warehouse Service.expertise')}
      key={'expertise'}
    />,
    <Video key='video' />,
    <Installations key='optionsStorage' />,
    <ContactStorage key='contactStorage' />,
  ];

  return (
    <StaticPageTemplate
      title={title}
      service={true}
      subtitle={subtitle}
      components={components}
    />
  );
}

function Video() {
  return (
    <div className='flex justify-center'>
      <iframe
        width='560'
        height='315'
        src='https://www.youtube-nocookie.com/embed/OH0LcEX-AD0?si=gqm9XjHU23dZI5dF'
        title='YouTube video player'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      />
    </div>
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      hasContainer: false,
    },
  };
};

export default MyPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services/warehouse-service',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  